export default "__VITE_ASSET__C0BR5DXp__"